import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="min-h-[70vh] flex items-center">
      <div className="max-w-7xl mx-auto px-6 w-full">
        <div className="eyebrow-row"><span className="eyebrow">Lost in space</span></div>
        <h1 className="display mt-6 text-7xl md:text-8xl lg:text-9xl">404.</h1>
        <p className="mt-6 text-white/65 max-w-md text-lg">
          The page you were looking for is not in this part of the universe.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/" className="btn-pill btn-primary">Return home</Link>
          <Link to="/today" className="btn-pill btn-secondary">Space Today</Link>
        </div>
      </div>
    </section>
  );
}
